import React, { useEffect } from "react";
import GraphsGrid from "../components/interpretation/GraphsGrid";
import { GraphsProvider } from "../context/GraphsProvider";
import useWasserman9Data from "./useWasserman9Data";
import useTestId from "./useTestId";
import { captureElement } from "../utils/capture-screen";
import { createPortal } from "react-dom";

function useGraphsCapture() {
    const [captureDataUrl, setCaptureDataUrl] = React.useState<string | null>(
        null
    );
    const testId = useTestId();
    const graphValues = useWasserman9Data({
        testId,
        enabled: true,
    });

    useEffect(() => {
        if (!graphValues.loading) {
            setTimeout(() => {
                captureElement("#graphs-grid-wasserman-9")
                    .then(setCaptureDataUrl)
                    .catch((error) => {
                        console.error("Error capturing graph:", error);
                    });
            }, 200);
        }
    }, [graphValues.loading]);

    const portal = createPortal(
        <div className="captureableElement fixed left-[-9999px]">
            <GraphsProvider contextValue={graphValues}>
                <GraphsGrid />
            </GraphsProvider>
        </div>,
        document.body
    );
    return { captureableElement: portal, captureDataUrl, setCaptureDataUrl };
}

export default useGraphsCapture;
